export function getArticleEditLink(articleId: string): string {
  return `https://app.intercom.com/a/apps/mll8fwo5/articles/articles/${articleId}/show`;
}
